/**
 * Utility class for generating customized logos based on location names
 */
class LogoGenerator {
    static colors = [
        '#2196F3', '#4CAF50', '#FF9800', '#9C27B0', '#F44336',
        '#00BCD4', '#8BC34A', '#FF5722', '#673AB7', '#3F51B5',
        '#009688', '#FFC107', '#795548', '#607D8B', '#E91E63'
    ];

    static generateLocationLogo(locationName) {
        if (!locationName || typeof locationName !== 'string') {
            console.warn('Invalid location name provided:', locationName);
            return null;
        }

        try {
            const words = locationName.trim().split(' ');
            let threeLetters;

            if (words.length >= 3) {
                // Filter out non-alphabetic characters and get first 3 letters
                const letters = words.slice(0, 3)
                    .map(word => word.charAt(0))
                    .filter(char => /[A-Za-z]/.test(char))
                    .join('')
                    .toUpperCase();
                threeLetters = letters.padEnd(3, 'X');
            } else if (words.length === 2) {
                const firstWord = words[0];
                const secondWord = words[1];
                const letters = (firstWord.charAt(0) + secondWord.charAt(0) + firstWord.charAt(1))
                    .replace(/[^A-Za-z]/g, '')
                    .toUpperCase();
                threeLetters = letters.padEnd(3, 'X');
            } else {
                threeLetters = locationName.substring(0, 3).toUpperCase().replace(/[^A-Za-z]/g, 'X');
            }

            if (threeLetters.length < 3) {
                threeLetters = threeLetters.padEnd(3, 'X');
            } else if (threeLetters.length > 3) {
                threeLetters = threeLetters.substring(0, 3);
            }

            // Create a simple hash of the location name for more varied colors
            let hash = 0;
            for (let i = 0; i < locationName.length; i++) {
                hash = ((hash << 5) - hash) + locationName.charCodeAt(i);
                hash = hash & hash; // Convert to 32-bit integer
            }
            const colorIndex = Math.abs(hash) % this.colors.length;
            const backgroundColor = this.colors[colorIndex];

            // Create a minimal SVG that should work
            const svg = `<svg width="200" height="200" xmlns="http://www.w3.org/2000/svg">
                <rect width="200" height="200" fill="${backgroundColor}"/>
                <text x="100" y="120" font-family="Arial" font-size="60" text-anchor="middle" fill="white">${threeLetters.replace(/&/g, '&amp;')}</text>
            </svg>`;

            // Convert SVG to data URL using base64 encoding with proper Unicode handling
            const dataUrl = `data:image/svg+xml;base64,${btoa(unescape(encodeURIComponent(svg)))}`;

            console.log('Generated logo for:', locationName, 'Letters:', threeLetters, 'Color:', backgroundColor);
            console.log('Data URL length:', dataUrl.length);
            console.log('SVG content:', svg);
            console.log('Data URL starts with:', dataUrl.substring(0, 100));
            console.log('Timestamp:', new Date().toISOString());

            // Return the actual generated logo
            return dataUrl;
        } catch (error) {
            console.error('Error generating logo for:', locationName, error);
            return null;
        }
    }

    /**
     * Generate a fallback logo with "BR" text
     * @returns {string} - Data URL of the fallback logo
     */
    static generateFallbackLogo() {
        const svg = `<svg xmlns="http://www.w3.org/2000/svg" width="200" height="200">
            <rect width="200" height="200" fill="#f0f0f0"/>
            <text x="100" y="120" font-family="Arial" font-size="60" text-anchor="middle" fill="#666666">BR</text>
        </svg>`;

        const fallbackUrl = `data:image/svg+xml;base64,${btoa(unescape(encodeURIComponent(svg)))}`;

        console.log('Generated fallback logo, URL length:', fallbackUrl.length);

        return fallbackUrl;
    }
}

export default LogoGenerator;
